<template>
    <v-dialog v-model="dialog" max-width="900" persistent>
        <v-card class="pa-6 rounded-lg" elevation="12">
            <loading v-if="loading" />

            <v-card-title class="text-h5 font-weight-bold primary--text d-flex align-center">
                <v-icon large color="primary" class="mr-3">mdi-school</v-icon>
                Histórico Académico
                <v-spacer />
            </v-card-title>

            <v-divider class="my-4"></v-divider>

            <!-- Student Info Card -->
            <v-card outlined class="mb-6 rounded-lg" v-if="academicHistory.length > 0">
                <v-card-text class="pa-4">
                    <v-row>
                        <v-col cols="12" md="4" class="d-flex align-center">
                            <v-icon color="info" class="mr-2">mdi-card-account-details</v-icon>
                            <span class="font-weight-medium">Nome:</span>
                            <span class="ml-2">{{ student.nome }}</span>
                        </v-col>
                        <v-col cols="12" md="4" class="d-flex align-center">
                            <v-icon color="info" class="mr-2">mdi-account</v-icon>
                            <span class="font-weight-medium">Matrícula:</span>
                            <span class="ml-2">{{ student.idMatricula }}</span>
                        </v-col>
                        <v-col cols="12" md="4" class="d-flex align-center">
                            <v-icon color="info" class="mr-2">mdi-identifier</v-icon>
                            <span class="font-weight-medium">Doc.:</span>
                            <span class="ml-2">{{ academicHistory[0].bi || '----' }}</span>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="4" class="d-flex align-center">
                            <v-icon color="info" class="mr-2">mdi-human-male-boy</v-icon>
                            <span class="font-weight-medium">Pai:</span>
                            <span class="ml-2">{{ academicHistory[0].nomedopai || '----' }}</span>
                        </v-col>
                        <v-col cols="12" md="4" class="d-flex align-center">
                            <v-icon color="info" class="mr-2">mdi-human-female-boy</v-icon>
                            <span class="font-weight-medium">Mãe:</span>
                            <span class="ml-2">{{ academicHistory[0].nomedamae || '----' }}</span>
                        </v-col>
                        <v-col cols="12" md="4" class="d-flex align-center">
                            <v-icon color="info" class="mr-2">mdi-gender-male-female</v-icon>
                            <span class="font-weight-medium">Sexo:</span>
                            <span class="ml-2">{{ academicHistory[0].sexo === 'M' ? 'Masculino' : 'Feminino' }}</span>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="4" class="d-flex align-center">
                            <v-icon color="info" class="mr-2">mdi-phone</v-icon>
                            <span class="font-weight-medium">Telefone:</span>
                            <span class="ml-2">{{ academicHistory[0].telefone || '----' }}</span>
                        </v-col>
                        <v-col cols="12" md="4" class="d-flex align-center">
                            <v-icon color="info" class="mr-2">mdi-email</v-icon>
                            <span class="font-weight-medium">Email:</span>
                            <span class="ml-2">{{ academicHistory[0].email || '----' }}</span>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card-text>
                <v-data-table :headers="headers" :items="academicHistory" :items-per-page="5"
                    class="elevation-2 rounded-lg"
                    :footer-props="{
                        'items-per-page-options': [5, 10, 15],
                        'show-current-page': true
                    }"
                    loading-text="Carregando histórico...">

                    <template v-slot:item.status_2="{ item }">
                        <v-chip small :color="getStatusColor(item.status_2)" text-color="white"
                            class="font-weight-bold">
                            <v-icon left small>{{ getStatusIcon(item.status_2) }}</v-icon>
                            {{ getStatusLabel(item.status_2) }}
                        </v-chip>
                    </template>

                    <template v-slot:item.resultado="{ item }">
                        <span :class="{ 'success--text': item.resultado, 'grey--text': !item.resultado }">
                            {{ item.resultado || '----' }}
                        </span>
                    </template>

                    <template v-slot:no-data>
                        <div class="text-center py-4">
                            <v-icon size="64" color="grey lighten-1">mdi-book-remove</v-icon>
                            <p class="subtitle-1 grey--text">Estudante sem histórico académico</p>
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>

             <v-card-actions class="pt-0 d-flex flex-wrap align-center">
  <!-- Switch: Trancar Matrícula -->
  <v-switch
    v-model="trancarMatricula"
    :label="label_trancar"
    color="error"
    inset
    hide-details
    class="mr-6"
    @change="confirmarTrancamento"
  >
    <template #prepend>
      <v-icon class="mr-2" color="error">mdi-lock</v-icon>
    </template>
  </v-switch>

  <!-- Switch: Habilitar Certificado -->
  <v-switch
    v-model="habilitarCertificado" 
    label="Habilitar Certificado"
    color="success"
    inset
    hide-details
    class="mr-6"
    @change="habilitaCertificado()"
    v-if="student.certificadoImpresso == '1' && role === 'ROLE_ADM'"
  >
    <template #prepend>
      <v-icon class="mr-2" color="success">mdi-certificate</v-icon>
    </template>
  </v-switch>

  <v-spacer />

  <!-- Botão Fechar à direita -->
  <v-btn
    color="primary"
    depressed
    large
    @click="$emit('cancel', false)"
    class="px-6 rounded-pill"
  >
    <v-icon left>mdi-close</v-icon>
    Fechar
  </v-btn>
</v-card-actions>


        </v-card>
    </v-dialog>
</template>

<script>
import axios from '../../../../plugins/axios';
import Swal from 'sweetalert2';
const ls = require('local-storage')

export default {
    name: 'AcademicHistoryDialog',
     
    props: {
        student: {
            type: Object,
            required: true
        }
    },
    components: {
        loading: () => import('../../../../components/loading.vue')
    },

    computed: {
        role(){
            return ls.get('role') //ROLE_ADM
        }
    },
    data() {
        return {
            dialog: true,
            academicHistory: [],
            label_trancar:'Trancar Matrícula',
            trancarMatricula: false,
            habilitarCertificado: false,
            loading: false,
            headers: [
                { text: "Curso", value: "curso", align: "start", class: "font-weight-bold" },
                { text: "Classe", value: "classe", align: "center" },
                { text: "Turma", value: "turma", align: "center" },
                { text: "Ano Lectivo", value: "novadescricao", align: "center" },
                { text: "Resultado", value: "resultado", align: "center" },
                { text: "Estado", value: "status_2", align: "center" }
            ]
        };
    },
    async created() {     
        console.log(this.student.certificadoImpresso);
           
        await this.fetchAcademicHistory();

    },
    methods: {
        async fetchAcademicHistory() {
            this.loading = true;
            try {
                const response = await axios.get(`/getStudentAcademicHistory/${this.student.idMatricula}`);
                this.academicHistory = response.data;
                this.verificaTrancada(this.academicHistory[0])
            } catch (error) {
                Swal.fire({
                    title: 'Error',
                    html: '<p class="body-1">Erro ao carregar o histórico do estudante.</p>',
                    icon: 'error',
                    confirmButtonColor: '#1976D2'
                });
            } finally {
                this.loading = false;
            }
        },

        verificaTrancada ( data ){
            if(data.status_2 === '2')
            {
                this.trancarMatricula = true
                this.label_trancar = 'Destrancar Matrícula'
            }
            else
            {
                this.label_trancar = 'Trancar Matrícula'
                this.trancarMatricula = false
            }
        },

        confirmarTrancamento(){

Swal.fire({
        title: 'Tem certeza?',
        text: `Você deseja realmente ${!this.trancarMatricula ? 'Destrancar': 'trancar'} a matrícula do estudante?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: `Sim, ${!this.trancarMatricula ? 'destrancar': 'trancar'} !`,
        cancelButtonText: 'Cancelar'
      }).then(async(result) => {
        if (result.isConfirmed) {
 
         let result = await axios.post('/trancarMatricula',{item: this.academicHistory[0], autor: ls.get('nomeUsuario'), op:(!this.trancarMatricula)?1:2}).then((res)=>res.data)
         if(result.affectedRows > 0){
           this.fetchAcademicHistory()
           Swal.fire('Informação','Matrícula trancada com successo','success')
        }
 
        } else {
          // Reverte o valor do switch
          this.trancarMatricula = false;
        }
 });
},

habilitaCertificado() {
     
  Swal.fire({
    title: 'Deseja habilitar o certificado?',
    text: "Essa ação permitirá a emissão do certificado para o estudante.",
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sim, habilitar',
    cancelButtonText: 'Cancelar'
  }).then(async(result) => {
    if (result.isConfirmed) {
      // Lógica para habilitar o certificado
       let result = await axios.post('/habilitarImpressaoCertificado',{pkPessoa:this.student.pkPessoa}).then((res)=>res.data)
       if(result.affectedRows > 0){

              Swal.fire(
                'Habilitado!',
                'O certificado foi habilitado com sucesso.',
                'success'
            );
       }else{
            Swal.fire(
            'Informação!',
            'Erro ao efectuar a operação.',
            'error'
        );
       }
    } else {
      // Ação opcional se o usuário cancelar
      console.log('Ação de habilitar certificado cancelada.');
    }
  });
},



        

        getStatusLabel(status) {
            switch (parseInt(status)) {
                case 0:
                    return 'Eliminada';
                case 1:
                    return 'Activo';
                case 2:
                    return 'Trancada';
                default:
                    return '----';
            }
        },

        getStatusIcon(status) {
            switch (parseInt(status)) {
                case 0:
                    return 'mdi-close-circle';
                case 1:
                    return 'mdi-check-circle';
                case 2:
                    return 'mdi-lock';
                default:
                    return 'mdi-help-circle';
            }
        },

        getStatusColor(status) {
            switch (parseInt(status)) {
                case 0:
                    return 'error';
                case 1:
                    return 'success';
                case 2:
                    return 'warning';
                default:
                    return 'grey';
            }
        }
    }
};
</script>

<style scoped>
.v-card {
    background: linear-gradient(to bottom, #f5f7fa 0%, #ffffff 100%);
}

.v-data-table {
    border-radius: 8px;
    overflow: hidden;
}

.v-chip.warning {
    background: linear-gradient(45deg, #FFC107, #FFA000);
}

.v-chip.success {
    background: linear-gradient(45deg, #4CAF50, #2E7D32);
}

.v-chip.error {
    background: linear-gradient(45deg, #F44336, #D32F2F);
}
</style>
